import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { Toaster as SonnerToaster } from 'sonner';
import '@fontsource-variable/inter';
import { Providers } from '@/app/providers';
import { buildRoutes } from '@/router';
import '@/app/globals.css';

/*
 * The application shell.
 *
 * This is what Next's root layout was, minus the parts only a server needed:
 * `<html>` and `<body>` live in index.html now, and the `suppressHydrationWarning`
 * they carried is meaningless in an app that never hydrates.
 *
 * Inter is self-hosted rather than fetched from Google. `next/font` did that for
 * us before, and an authenticated back office making a third-party request on
 * every cold load — to a host that then sees every one of our staff — is not a
 * trade worth making for a font file Cloudflare will serve from the same edge.
 *
 * The providers sit ABOVE the router: Apollo and Firebase auth outlive any one
 * route, and putting them inside would tear down the client on every navigation.
 */
const root = document.getElementById('root');
if (!root) throw new Error('index.html is missing #root');

createRoot(root).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={createBrowserRouter(buildRoutes())} />
      <SonnerToaster richColors position="bottom-right" closeButton expand />
    </Providers>
  </StrictMode>,
);
